<ng-template #iconTpl let-key>
  <ng-container [ngSwitch]="key">

    <!-- Recruitment: two people -->
    <svg *ngSwitchCase="'recruitment'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="9" cy="7" r="3"/>
      <path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      <path d="M21 21v-2a4 4 0 0 0-3-3.87"/>
    </svg>

    <!-- Employee: person with briefcase -->
    <svg *ngSwitchCase="'employee'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="7" r="4"/>
      <path d="M5 20v-1a7 7 0 0 1 14 0v1"/>
      <rect x="8" y="14" width="8" height="6" rx="1"/>
      <path d="M10 14v-2a2 2 0 0 1 4 0v2"/>
    </svg>

    <!-- Payroll: wallet / card -->
    <svg *ngSwitchCase="'payroll'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="2" y="6" width="20" height="13" rx="2"/>
      <path d="M2 11h20"/>
      <circle cx="16" cy="16" r="2"/>
      <path d="M7 16h4"/>
    </svg>

    <!-- Tasks: clipboard with checkmark -->
    <svg *ngSwitchCase="'tasks'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="5" y="3" width="14" height="18" rx="2"/>
      <path d="M9 8h6"/>
      <path d="M9 12l2 2 4-4"/>
      <path d="M9 17h4"/>
    </svg>

    <!-- Report & Analytics: bar chart + trend -->
    <svg *ngSwitchCase="'reports'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <line x1="3" y1="20" x2="21" y2="20"/>
      <rect x="5" y="13" width="4" height="7"/>
      <rect x="10" y="8" width="4" height="12"/>
      <rect x="15" y="4" width="4" height="16"/>
      <polyline points="5,9 10,5 15,7 20,3"/>
    </svg>

    <!-- Leads: funnel -->
    <svg *ngSwitchCase="'leads'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 4h18l-6.5 7.5v7l-5 2.5v-9.5z"/>
    </svg>

    <!-- Quotations: document with lines -->
    <svg *ngSwitchCase="'quotations'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="5" y="3" width="14" height="18" rx="2"/>
      <path d="M8 8h3M8 12h8M8 16h5"/>
    </svg>

    <!-- Sales Orders: cart -->
    <svg *ngSwitchCase="'sales-orders'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="9" cy="20" r="1"/>
      <circle cx="18" cy="20" r="1"/>
      <path d="M2 3h2l2.4 12.4a2 2 0 0 0 2 1.6h8.6a2 2 0 0 0 2-1.6L21 7H6"/>
    </svg>

    <!-- Invoicing: receipt -->
    <svg *ngSwitchCase="'invoicing'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M6 3h12v18l-3-2-3 2-3-2-3 2z"/>
      <path d="M9 8h6M9 12h6M9 16h4"/>
    </svg>

    <!-- Stock Management: stacked boxes -->
    <svg *ngSwitchCase="'stock'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 3l9 5-9 5-9-5 9-5z"/>
      <path d="M3 8v8l9 5 9-5V8"/>
      <path d="M12 13v8"/>
    </svg>

    <!-- Warehouses: building -->
    <svg *ngSwitchCase="'warehouse'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 21V9l9-5 9 5v12"/>
      <path d="M9 21v-6h6v6"/>
    </svg>

    <!-- Stock Transfers: swap arrows -->
    <svg *ngSwitchCase="'transfer'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M17 3l4 4-4 4"/>
      <path d="M21 7H8"/>
      <path d="M7 21l-4-4 4-4"/>
      <path d="M3 17h13"/>
    </svg>

    <!-- Barcode Scanning: barcode -->
    <svg *ngSwitchCase="'barcode'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <line x1="4" y1="4" x2="4" y2="20"/>
      <line x1="7" y1="4" x2="7" y2="20"/>
      <line x1="10.5" y1="4" x2="10.5" y2="20" stroke-width="3"/>
      <line x1="14" y1="4" x2="14" y2="20"/>
      <line x1="17.5" y1="4" x2="17.5" y2="20" stroke-width="3"/>
      <line x1="20" y1="4" x2="20" y2="20"/>
    </svg>

    <!-- Purchase Orders: incoming box -->
    <svg *ngSwitchCase="'purchase-orders'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="4" y="7" width="16" height="13" rx="2"/>
      <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
      <path d="M9 13h6"/>
    </svg>

    <!-- Vendor Management: storefront -->
    <svg *ngSwitchCase="'vendor'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 9l1-5h16l1 5"/>
      <path d="M4 9v11h16V9"/>
      <path d="M9 20v-6h6v6"/>
    </svg>

    <!-- RFQ: question document -->
    <svg *ngSwitchCase="'rfq'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="5" y="3" width="14" height="18" rx="2"/>
      <path d="M10 9a2 2 0 1 1 3 1.7c-.6.4-1 1-1 1.8"/>
      <path d="M12 16h.01"/>
    </svg>

    <!-- Purchase Approvals: shield check -->
    <svg *ngSwitchCase="'approvals'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 3l7 3v6c0 5-3 7-7 9-4-2-7-4-7-9V6z"/>
      <path d="M9 12l2 2 4-4"/>
    </svg>

    <!-- Bill of Materials: indented list -->
    <svg *ngSwitchCase="'bom'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 6h4M4 12h4M4 18h4"/>
      <path d="M10 6h10M12 12h8M14 18h6"/>
    </svg>

    <!-- Work Orders: wrench -->
    <svg *ngSwitchCase="'work-orders'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.8 2.8-2-2z"/>
    </svg>

    <!-- Production Planning: factory -->
    <svg *ngSwitchCase="'production'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 21V10l5 3V10l5 3V7l6 4v10z"/>
      <path d="M3 21h18"/>
    </svg>

    <!-- Quality Control: badge check -->
    <svg *ngSwitchCase="'quality'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="9" r="6"/>
      <path d="M9.5 9l1.7 1.7L14.5 7"/>
      <path d="M8 14.5l-2 6 6-3 6 3-2-6"/>
    </svg>

    <!-- Contact Management: address card -->
    <svg *ngSwitchCase="'contacts'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="4" y="3" width="16" height="18" rx="2"/>
      <circle cx="12" cy="10" r="3"/>
      <path d="M8 17c0-2 2-3 4-3s4 1 4 3"/>
    </svg>

    <!-- Deals Pipeline: kanban columns -->
    <svg *ngSwitchCase="'pipeline'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="4" width="5" height="16" rx="1"/>
      <rect x="10" y="4" width="5" height="10" rx="1"/>
      <rect x="17" y="4" width="5" height="13" rx="1"/>
    </svg>

    <!-- Customer Support: headset -->
    <svg *ngSwitchCase="'support'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 13v-1a8 8 0 0 1 16 0v1"/>
      <rect x="2" y="13" width="4" height="6" rx="2"/>
      <rect x="18" y="13" width="4" height="6" rx="2"/>
      <path d="M20 19v1a3 3 0 0 1-3 3h-2"/>
    </svg>

    <!-- Campaigns: megaphone -->
    <svg *ngSwitchCase="'campaigns'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 10v4h3l5 4V6l-5 4z"/>
      <path d="M14 9a3 3 0 0 1 0 6"/>
      <path d="M17 6a7 7 0 0 1 0 12"/>
    </svg>

  </ng-container>
</ng-template>

<section class="product-apps-section">
  <div class="product-apps-wrapper">

    <!-- Left: app groups -->
    <div class="apps-left">
      <div class="product-group" *ngFor="let group of groups">
        <h3 class="group-heading">{{ group.heading }}</h3>
        <div class="product-grid">
          <button
            *ngFor="let product of group.products"
            class="product-tile"
            [class.selected]="isSelected(product)"
            [class.disabled]="isLimitReached() && !isSelected(product)"
            [disabled]="isLimitReached() && !isSelected(product)"
            (click)="toggleProduct(product)"
            type="button"
          >
            <span class="check-badge" *ngIf="isSelected(product)">&#10003;</span>

            <!-- Icon -->
            <div class="icon-box" [style.color]="group.color">
              <ng-container *ngTemplateOutlet="iconTpl; context: { $implicit: product.iconKey }"></ng-container>
            </div>

            <!-- Text -->
            <div class="tile-text">
              <span class="tile-name">{{ product.label }}</span>
              <span class="tile-subtitle">{{ product.subtitle }}</span>
            </div>

          </button>
        </div>
      </div>
    </div>

    <!-- Right: selection panel (desktop card / mobile sticky bar) -->
    <div class="selection-panel" *ngIf="selectedProducts.length > 0">
      <div class="panel-inner">

        <div class="selected-icons-row">
          <div class="mini-icon" *ngFor="let p of selectedProducts.slice(0, 5)">
            <ng-container *ngTemplateOutlet="iconTpl; context: { $implicit: p.iconKey }"></ng-container>
          </div>
          <span class="mini-icon-more" *ngIf="selectedProducts.length > 5">+{{ selectedProducts.length - 5 }}</span>
        </div>

        <p class="selected-count">
          <strong>{{ selectedProducts.length }}</strong>
          {{ selectedProducts.length === 1 ? 'App' : 'Apps' }} selected
        </p>

        <p class="limit-note" *ngIf="isLimitReached()">
          Maximum {{ maxSelectable }} apps can be selected at a time.
        </p>

        <div class="info-box">
          <strong>Free</strong>, with unlimited users, forever.
        </div>

        <button
          class="continue-btn"
          [disabled]="selectedProducts.length === 0"
          (click)="onContinue()"
          type="button"
        >
          Continue
        </button>
      </div>
    </div>

  </div>
</section>
